export default __webpack_public_path__ + "static/media/close_red.fa7e5ead.svg";